import React, { Component } from 'react';
import { Button, ButtonToolbar, Form, FormGroup, ControlLabel, Modal, FormControl, Checkbox, HelpBlock } from 'react-bootstrap';
import Select from 'react-select';

export class PathStopDraftForm extends Component {

    render() {
        const { show, form, stops, regions } = this.props;

        if (undefined === form || !show) {
            return null;
        }

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formStop" validationState={form.stopInputError}>
                            <ControlLabel>Paragem</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma paragem"
                                noOptionsMessage={() => "Sem Paragens Configuradas"}
                                onChange={(e) => this.props.onSelectValue(null === e ? undefined : e.id, "stopId")}
                                options={stops.sort((a, b) => a.name !== b.name ? a.name < b.name ? -1 : 1 : 0)}
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value.id}
                                getOptionLabel={label => `${label.name} (${label.code})`}
                                value={stops.find(stop => stop.id === form.obj.stopId)}
                            />
                            {form.stopInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formPrevDistance" validationState={form.distanceInputError}>
                            <ControlLabel>Distância em metros</ControlLabel>
                            <FormControl
                                type="number"
                                min="0"
                                value={form.obj.prevDistance}
                                placeholder="Introduza a distância"
                                onChange={(e) => this.props.onChangeValue(e, 'prevDistance')}
                            />
                            {form.distanceInputError !== null
                                ?
                                <HelpBlock> Introduza um valor positivo. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formDuration" validationState={form.durationInputError}>
                            <ControlLabel>Duração em minutos</ControlLabel>
                            <FormControl
                                type="number"
                                min="0"
                                value={form.obj.duration}
                                placeholder="Introduza a duração"
                                onChange={(e) => this.props.onChangeValue(e, 'duration')}
                            />
                            {form.durationInputError !== null
                                ?
                                <HelpBlock> Introduza um valor positivo. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formSpine">
                            <Checkbox className="form-checkbox" defaultChecked={form.obj.inSpine} onChange={(e) => this.props.onCheckValue(e, "inSpine")}>
                                Presente na Espinha
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formLineRegions">
                            <ControlLabel>Regiões</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione as Regiões"
                                noOptionsMessage={() => "Sem Regiões Configuradas"}
                                onChange={(e) => this.props.onSelectValue(e, "regions")}
                                options={regions}
                                isMulti={true}
                                isOptionSelected={function (a) {
                                    if (undefined !== form.obj.regions) {
                                        return form.obj.regions.map(region => region.id).includes(a.id);
                                    }
                                }}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={form.obj.regions}
                            />
                        </FormGroup>
                    </Form>

                    <ButtonToolbar>
                        <Button onClick={() => this.props.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>

            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/pathStops/PathStopDraftForm.js